import _ from 'lodash';

import { areaIsMain } from 'components/base';
import { AppUser, Area, Route } from 'core/model';
import { ACCESS_TYPES } from 'core/utils/constants';
import Utils from 'core/utils/utils';
import getSystemRoutes from 'scenes/dashboard/helpers/getSystemRoutes';
import routes from 'scenes/dashboard/routes';

const unreleasedRoutes = ['/dev'];

const getFilteredRoutes = (
  currentUser: AppUser,
  area: Area,
  isProd: boolean,
  localMode: boolean
) => {
  // determine if the user is an admin and is online to show admin accessible routes
  const userIsAdmin =
    !localMode && Utils.canAccess(currentUser, ACCESS_TYPES.admin);
  const isAdminDebug = userIsAdmin && !isProd && areaIsMain(area);
  const noUnreleasedMain = !unreleasedRoutes && areaIsMain(area);

  // filter
  const filteredRoutes =
    routes && currentUser
      ? routes
          .filter((r: Route) => {
            if (isAdminDebug || noUnreleasedMain) {
              // allow all routes
              return true;
            }

            // else
            return (
              // if prod or in area (not main area) or non-admin user...
              (isProd || !areaIsMain(area) || !userIsAdmin) &&
              // ...hide unreleased routes
              !_.some(unreleasedRoutes, (ur) => ur === r.path) &&
              // ...and then filter by area
              (areaIsMain(area) || r.areable)
            );
          })
          .filter((route: Route) => {
            if (route.path === '/admin') {
              return userIsAdmin && areaIsMain(area);
            } else if (route.path === '/reporting') {
              return Utils.canAccess(currentUser, 'reporting');
            } else if (route.path === '/analytics') {
              return Utils.canAccess(currentUser, 'analytics');
            }

            return true;
          })
      : undefined;

  // apply area routing
  return getSystemRoutes(filteredRoutes, area);
};

export default getFilteredRoutes;
